import poster from "../../assets/tot-img/poster.jpg";
import guidelines from "../../assets/tot-img/guidelines.jpg";
import schedule from "../../assets/tot-img/schedule.jpg";

export const imgData = [
    {
        img: poster,
        title: "Poster"
    },
    {
        img: guidelines,
        title: "Guidelines",
    },
    {
        img: schedule,
        title: "Schedule"
    }
];